import Vue from 'vue';
import Component from 'vue-class-component';
import { Jurisdiction } from '@gig/magic-jurisdictions';
import { USER_JURISDICTION_UPDATED } from '@gig/magic-messages';
import { ISubscription } from '@gig/magic-message-bus/dist/base-bus';

@Component
export class JurisdictionMixin extends Vue {
    private subscription: ISubscription | undefined;
    currentJurisdiction: Jurisdiction | null = null;

    get isLOTBA(): boolean {
        return this.currentJurisdiction === Jurisdiction.LOTBA;
    }
    get isONJN(): boolean {
        return this.currentJurisdiction === Jurisdiction.ONJN;
    }
    get isAGCO(): boolean {
        return this.currentJurisdiction === Jurisdiction.AGCO;
    }
    get isAGLC(): boolean {
        return this.currentJurisdiction === Jurisdiction.AGLC;
    }
    get isSGA(): boolean {
        return this.currentJurisdiction === Jurisdiction.SGA;
    }
    get isUKGC(): boolean {
        return this.currentJurisdiction === Jurisdiction.UKGC;
    }
    get isEMTA(): boolean {
        return this.currentJurisdiction === Jurisdiction.EMTA;
    }

    created() {
        this.subscription = window.eventBus.subscribe<Jurisdiction>(
            USER_JURISDICTION_UPDATED,
            (event) => {
                this.currentJurisdiction = event.payload!;
            },
            { replay: true },
        );
    }

    destroyed() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
